import React, { useEffect, useRef, useState } from "react";
import { Layout, Button, Modal } from "antd";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import {
  FaArrowRight,
  FaCheckCircle,
  FaMedal,
  FaRegClock,
} from "react-icons/fa";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoIosMail } from "react-icons/io";
import { ImageUrl } from "../../helpers/Functions";
import "./b2b-training.css";

function Homepage() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userData);
  const token = useSelector((state) => state.user.userToken);
  const [modal2Open, setModal2Open] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    if (modal2Open && videoRef.current) {
      videoRef.current.play().catch((error) => {
        console.log("Autoplay failed:", error);
      });
    }
  }, [modal2Open]);

  React.useEffect(() => {
    if (!user && !token) {
      navigate("/", { replace: true });
    }
  }, [user, token, navigate]);

  const data = [
    { title: "Zoom." },
    { title: "Microsoft Teams." },
    { title: "GoToWebinar and GoToMeeting." },
    { title: "Vimeo" },
  ];

  const data2 = [
    { title: "Assign an instructor to class." },
    { title: "Choose class start and end times." },
    {
      title: "Include online live classes inside of a self-paced course.",
    },
  ];

  const data3 = [
    {
      Icon: GiHamburgerMenu,
      title: "Sell Course Seats Online",
      des: "Create in-person classes that users can register for online. Schedule class dates, location, and assign instructors.",
    },
    {
      Icon: FaRegClock,
      title: "Keep Track Of Your Attendees",
      des: "Update and manage attendance. Add or remove students from class.",
    },
    {
      Icon: FaMedal,
      title: "Enroll Users Into Courses",
      des: "Enroll students into classes manually, in bulk, or offer self-enrollment.",
    },
    {
      Icon: IoIosMail,
      title: "Send Email Reminders",
      des: "Automate emails to notify users of important details after enrolling into a course.",
    },
  ];

  const data4 = [
    {
      title: "Log in and train directly after purchasing a course online.",
    },
    {
      title: "Organizations can purchase training in bulk for their company.",
    },
  ];

  return (
    <Layout className="b2b-page">
      <section
        className="b2b-hero"
        style={{ backgroundImage: `url(${ImageUrl("new-10.png")})` }}
      >
        <div className="b2b-hero-overlay" aria-hidden />
        <div className="b2b-wrap b2b-hero-inner">
          <div className="b2b-hero-copy">
            <span className="b2b-hero-badge">INSTRUCTOR-LED TRAINING</span>
            <h1 className="fontFamily1 b2b-hero-title">
              Host Webinars, Live Online Classes, And{" "}
              <span>In-Person Training</span>
            </h1>
            <p className="fontFamily1 b2b-hero-sub">
              Engage your learners in real-time using webinars, in-person
              classes, and online courses. Schedule, host, and manage
              instructor-led training with one platform.
            </p>
            <div className="b2b-hero-actions">
              <Button
                type="primary"
                className="b2b-hero-btn-primary"
                onClick={() => navigate("/signup")}
              >
                Register Now
              </Button>
              <Button
                className="b2b-hero-btn-outline"
                onClick={() => setModal2Open(true)}
              >
                See The Platform <FaArrowRight />
              </Button>
            </div>
          </div>
        </div>
      </section>

      <section className="b2b-section b2b-section--white">
        <div className="b2b-wrap">
          <div className="b2b-split">
            <div className="b2b-split-media">
              <img src={ImageUrl("coursebanner2.png")} alt="" loading="lazy" />
            </div>
            <div className="b2b-split-copy">
              <img
                src={ImageUrl("miniImg.png")}
                alt=""
                className="b2b-section-kicker"
              />
              <h2 className="fontFamily1">
                Connect Your Video Conferencing Apps
              </h2>
              <p>
                Connect with webinar tools to schedule, host, and manage
                instructor-led training using only one platform. WrightCo academy
                supports different video conferencing apps:
              </p>
              <ul className="b2b-check-list">
                {data.map((item) => (
                  <li key={item.title}>
                    <FaCheckCircle aria-hidden />
                    <span>{item.title}</span>
                  </li>
                ))}
              </ul>
              <Button
                className="b2b-btn-ghost"
                onClick={() => navigate("/pricingPlans")}
              >
                See Pricing
              </Button>
            </div>
          </div>
        </div>
      </section>

      <section className="b2b-section b2b-section--muted">
        <div className="b2b-wrap">
          <div className="b2b-section-intro">
            <h2 className="fontFamily1 b2b-section-title">
              Deliver Education & Courses In-Person Or Online
            </h2>
            <p className="fontFamily1 b2b-section-lead">
              You can deliver and manage instructor-led training in different
              ways using WrightCo Academy—report on attendance and user
              engagement later.
            </p>
          </div>

          <div className="b2b-cards">
            <article className="b2b-card">
              <div className="b2b-card-media">
                <img src={ImageUrl("new-11.png")} alt="" loading="lazy" />
              </div>
              <div className="b2b-card-body">
                <h3>Create Recurring Classes</h3>
                <p>
                  Choose a location, instructor, how often a class reoccurs, and
                  the date a class starts and ends. Recurring classes can be
                  online or in-person.
                </p>
                <Button
                  className="b2b-btn-ghost"
                  style={{ marginTop: 14 }}
                  onClick={() => navigate("/pricingPlans")}
                >
                  See Pricing
                </Button>
              </div>
            </article>
            <article className="b2b-card">
              <div className="b2b-card-media">
                <img src={ImageUrl("new-12.png")} alt="" loading="lazy" />
              </div>
              <div className="b2b-card-body">
                <h3>Host One-Time Webinars</h3>
                <p>
                  No more juggling between different platforms to create and
                  manage Webinars. Users can join a webinar directly inside of
                  the LMS.
                </p>
                <Button
                  className="b2b-btn-ghost"
                  style={{ marginTop: 14 }}
                  onClick={() => navigate("/pricingPlans")}
                >
                  See Pricing
                </Button>
              </div>
            </article>
            <article className="b2b-card">
              <div className="b2b-card-media">
                <img src={ImageUrl("new-13.png")} alt="" loading="lazy" />
              </div>
              <div className="b2b-card-body">
                <h3>Teach In-Person Courses</h3>
                <p>
                  Schedule, sell registrations for, and manage in-person classes
                  with the WrightCo Academy software. In-person courses can be
                  one-time or reccuring.
                </p>
                <Button
                  className="b2b-btn-ghost"
                  style={{ marginTop: 14 }}
                  onClick={() => navigate("/pricingPlans")}
                >
                  See Pricing
                </Button>
              </div>
            </article>
          </div>
        </div>
      </section>

      <section className="b2b-section b2b-section--white">
        <div className="b2b-wrap">
          <div className="b2b-split">
            <div className="b2b-split-copy">
              <img
                src={ImageUrl("miniImg.png")}
                alt=""
                className="b2b-section-kicker"
              />
              <h2 className="fontFamily1">Create Engaging Online Classrooms</h2>
              <p>
                Host one-time or recurring online classes. Live classrooms are
                great for teaching curriculum, engaging users, and answering
                questions in real-time.
              </p>
              <ul className="b2b-check-list">
                {data2.map((item) => (
                  <li key={item.title}>
                    <FaCheckCircle aria-hidden />
                    <span>{item.title}</span>
                  </li>
                ))}
              </ul>
              <Button
                className="b2b-btn-ghost"
                onClick={() => navigate("/pricingPlans")}
              >
                See Pricing
              </Button>
            </div>
            <div className="b2b-split-media">
              <img src={ImageUrl("new-14.png")} alt="" loading="lazy" />
            </div>
          </div>
        </div>
      </section>

      <section className="b2b-section b2b-section--navy">
        <div className="b2b-wrap">
          <div className="b2b-section-intro">
            <h2 className="fontFamily1 b2b-section-title">
              Manage In-Person And Online Training With The Same Tool
            </h2>
            <p className="fontFamily1 b2b-section-lead">
              Sell and manage in-person training classes with the same platform
              that you use for on-demand courses and webinars.
            </p>
            {!token && (
              <div className="b2b-cta-center">
                <Button
                  className="b2b-btn-light"
                  onClick={() => navigate("/signup")}
                >
                  Get Started
                </Button>
              </div>
            )}
          </div>

          <div className="b2b-split">
            <div className="b2b-split-media">
              <img src={ImageUrl("new-15.png")} alt="" loading="lazy" />
            </div>
            <div className="b2b-split-copy">
              <ul className="b2b-feature-list">
                {data3.map((item) => {
                  const Icon = item.Icon;
                  return (
                    <li key={item.title}>
                      <span className="b2b-feature-icon" aria-hidden>
                        <Icon />
                      </span>
                      <div>
                        <h4>{item.title}</h4>
                        <p>{item.des}</p>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="b2b-section b2b-section--muted">
        <div className="b2b-wrap">
          <div className="b2b-split">
            <div className="b2b-split-copy">
              <img
                src={ImageUrl("miniImg.png")}
                alt=""
                className="b2b-section-kicker"
              />
              <h2 className="fontFamily1">Sell Training Course Online</h2>
              <p>
                Sell accredited training to businesses, individuals, and
                Continuing Education providers. Sell courses directly on the
                platform with built-in eCommerce, or integrate with an existing
                store of yours like Shopify.
              </p>
              <ul className="b2b-check-list">
                {data4.map((item) => (
                  <li key={item.title}>
                    <FaCheckCircle aria-hidden />
                    <span>{item.title}</span>
                  </li>
                ))}
              </ul>
              <Button
                className="b2b-btn-ghost"
                onClick={() => navigate("/pricingPlans")}
              >
                See Pricing
              </Button>
            </div>
            <div className="b2b-split-media">
              <img src={ImageUrl("new-16.png")} alt="" loading="lazy" />
            </div>
          </div>
        </div>
      </section>

      <section className="b2b-section b2b-section--navy">
        <div className="b2b-wrap">
          <div className="b2b-split">
            <div className="b2b-split-media">
              <img src={ImageUrl("new-17.png")} alt="" loading="lazy" />
            </div>
            <div className="b2b-split-copy">
              <img
                src={ImageUrl("miniImg2.png")}
                alt=""
                className="b2b-section-kicker"
              />
              <h2 className="fontFamily1">
                Do You Have LMS Questions? Or Custom eLearning Needs?
              </h2>
              <p>
                Our #1 goal is to help you find a learning platform that works
                for you. If you have questions about our software or our
                services - let’s answer those.
              </p>
              <div className="b2b-hero-actions">
                {!token && (
                  <Button
                    className="b2b-btn-light"
                    onClick={() => navigate("/signup")}
                  >
                    Get Started
                  </Button>
                )}
                <Button
                  className="b2b-hero-btn-outline"
                  onClick={() => navigate("/pricingPlans")}
                >
                  See Pricing
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="b2b-trainer">
        <div className="b2b-wrap">
          <div className="b2b-trainer-card">
            <h3>We&apos;re Looking for Trainers</h3>
            <h3>Teach. Create. Earn.</h3>
            <p>
              Are you passionate about teaching? Ready to share your expertise,
              connect with professionals, and make a meaningful impact, all
              while earning extra income?
            </p>

            <h4>You&apos;ve come to the right place.</h4>
            <p>
              At WrightCo Academy, we are building a network of world-class
              trainers and industry experts dedicated to developing high-quality
              courseware for professionals in early care and education. If
              you&apos;re an expert in your field with a desire to teach,
              we&apos;d love to have you on board!
            </p>

            <h3>Why Join Us?</h3>
            <ul>
              <li>
                <p>
                  ✅ Expand Your Reach – Share your knowledge with a broad
                  audience of professionals.
                </p>
              </li>
              <li>
                <p>
                  ✅ Boost Your Visibility – Gain recognition as a trusted expert
                  in your industry.
                </p>
              </li>
              <li>
                <p>
                  ✅ Join a Thriving Community – Connect with like-minded trainers
                  and industry leaders.
                </p>
              </li>
              <li>
                <p>
                  ✅ Earn Passive Income – Our fair and flexible revenue-sharing
                  model ensures unlimited earning potential.
                </p>
              </li>
            </ul>

            <h3>What It Takes to Be a WrightCo Trainer</h3>
            <ul>
              <li>
                <p>
                  ✔ <strong>Passion for Teaching</strong> – A commitment to
                  sharing knowledge and empowering others.
                </p>
              </li>
              <li>
                <p>
                  ✔ <strong>Industry Expertise</strong> – Relevant certifications
                  and experience in your domain.
                </p>
              </li>
              <li>
                <p>
                  ✔ <strong>Strong Communication Skills</strong> – Ability to
                  present information effectively.
                </p>
              </li>
              <li>
                <p>
                  ✔ <strong>Commitment to Excellence</strong> – Willingness to
                  develop and deliver high-quality training.
                </p>
              </li>
            </ul>
            <h4>Ready to Make an Impact?</h4>
            <p>
              Join WrightCo Academy today and take the next step in your teaching
              journey.
            </p>
          </div>
        </div>
      </section>

      <Modal
        className="b2b-video-modal"
        centered
        open={modal2Open}
        onOk={() => setModal2Open(false)}
        onCancel={() => setModal2Open(false)}
        width={1000}
        footer={false}
      >
        <div style={{ padding: "24px 12px" }}>
          <video width="auto" height="auto" ref={videoRef} controls>
            <source src="https://react.customdev.solutions:3012/Uploads/tutorVideo.mp4" />
            <source src="movie.ogg" type="video/ogg" />
          </video>
        </div>
      </Modal>
    </Layout>
  );
}

export default Homepage;
